import { IconContent } from '@icons';

export const checkmarkCircle: IconContent = {
    sm: '<path d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13ZM.5 8a7.5 7.5 0 1 1 15 0 7.5 7.5 0 0 1-15 0Zm11.666-1.646-5.041 5.04-2.979-2.978.708-.707L7.125 9.98l4.334-4.334.707.708Z" />',
    md: '<path fill-rule="evenodd" d="M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm1 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9.678 2.697 4.688-4.687-.707-.707-4.334 4.334-2.272-2.272-.707.707 2.625 2.625.354.354.353-.354Z" />',
};
